import { you } from './PersonaName.locstring.json';
import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import * as React from 'react';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

import styles from './Persona.scss';
import classNames from 'classnames';

export default observer(function PersonaName(props: PersonaCardBehaviorProps) {
    const PersonaCardBehavior = useLivePersonaCard({
        ...props,
        className: classNames(styles.persona, props.className),
    });
    const { name, emailAddress } = props;

    return (
        <PersonaCardBehavior>
            <span className={classNames(styles.personaName, 'allowTextSelection')}>
                {emailAddress === getUserConfiguration().SessionSettings.UserEmailAddress
                    ? loc(you)
                    : name}
            </span>
        </PersonaCardBehavior>
    );
});
